import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { ResourceCountService } from '../../services/resource-count/resource-count.service';

@Component({
  selector: 'app-disengagement-setup-modal',
  templateUrl: './disengagement-setup-modal.component.html',
  styleUrls: ['./disengagement-setup-modal.component.scss']
})
export class DisengagementSetupModalComponent implements OnInit {
  @Input()
  callcard: CallCard;

  peopleCount: number;

  constructor(private modalController: ModalController, private resourceCount: ResourceCountService) {}

  ngOnInit() {
    this.peopleCount = this.resourceCount.getEngagedPeople(this.callcard);
  }

  onSubmit() {
    this.modalController.dismiss({ peopleCount: this.peopleCount });
  }

  onDismiss() {
    this.modalController.dismiss();
  }

  onPeopleCountClicked() {
    this.resourceCount
      .selectEngagedPeople()
      .then(value => (this.peopleCount = value))
      .catch(err => err);
  }
}
